module.exports = {
  PLUGIN_NAME: 'datadog-apm',
  BLAZE_DATADOG_ENVIRONMENT: 'production',
  BLAZE_DATADOG_APM_UI_SERVICES: 'http,graphql',
  BLAZE_DATADOG_APM_API_SERVICES: 'http,graphql,elasticsearch,fs,koa,mongodb-core,redis'
};
